import { render, staticRenderFns } from "./CardAgregarFirma.vue?vue&type=template&id=bef26dec&scoped=true"
import script from "./CardAgregarFirma.vue?vue&type=script&lang=js"
export * from "./CardAgregarFirma.vue?vue&type=script&lang=js"
import style0 from "./CardAgregarFirma.vue?vue&type=style&index=0&id=bef26dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef26dec",
  null
  
)

export default component.exports